import { aspCond } from '@module/helpers/conditions/condition';
import type { ParsedPersonalMessage } from '@module/types/centrifuge/messageTypes';
import { isPersonalUserStopMessage, type PersonalUserStopMessage } from '@module/types/centrifuge/personalMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class PersonalUserStopHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<PersonalUserStopMessage>) {}

  canHandle(payload: ParsedPersonalMessage): boolean {
    return isPersonalUserStopMessage(payload);
  }

  async handle(payload: PersonalUserStopMessage, context: MessageHandlerContext): Promise<void> {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.dispose?.();
    context.disconnectSocket?.();

    const message = payload.data.message.message ?? '회원님께서는 사이트 내 방송 서비스 이용이 정지되었습니다.';

    if (context.hsms) {
      await context.hsms.openModal(
        'Confirm',
        { title: message, isShowCancelButton: false, confirmText: '確認' },
        { size: 'mid' },
      );
      context.router?.push('/');
      aspCond.if('iframe-asp') && context.router?.push('/asp/auth/out');
    } else if (context.pushModal) {
      context.pushModal({
        type: 'CONFIRM_MODAL',
        options: {
          description: message,
          onClose: () => {
            context.clearModals?.();
            context.router?.push('/');
            aspCond.if('iframe-asp') && context.router?.push('/asp/auth/out');
          },
        },
      });
    }
  }
}
